import { Helpers } from '../../helpers';
import { IFracGroup } from '../../interfaces/ifrac-group';
import { DrillGroup } from '../drill-group';
import { FracGroupWell } from '../frac-group-well';
import { GroupRelationship } from '../group-relationship';
import { Pad } from '../pad';
import { ProductionGroup } from '../production-group';
import { ScenarioDrillFracOverlap } from '../scenario-drill-frac-overlap';
import { ScenarioWell } from '../scenario-well';
import { ScenarioWellShutIn } from '../scenario-well-shut-in';
import { ScheduleActivity } from '../schedule-activity';

export class FracGroupBase {
  FracGroupId: number;
  ScenarioId: number | null;
  FracFleetId: number | null;
  Description: string | null;
  ProcessingOrder: number;
  Lag: number;
  InternalContingent: boolean;
  InternalContingentComments: string | null;
  Contingent: boolean;
  ContingentComments: string | null;
  PadId: number | null;
  BoundsOfWells_Computed: object | null;
  CenterOfWells_Computed: object | null;
  BoundsofWellsSetDate: Date | null;
  SourceDrillGroupId: number | null;
  SysActionUID: string | null;
  SysStartTime: Date;
  SysEndTime: Date;
  StartNoEarlierThan: Date | null;
  StartNoLaterThan: Date | null;
  FirstWellStart: Date | null;
  LastWellEnd: Date | null;
  FracDesignId: number | null;
  IsManuallyAdded: boolean;
  IsFromBaseScenario: boolean;
  SourceBaseScenarioFracGroupId: number | null;
  SourceBaseScenarioDrillGroupId: number | null;
  CreationOrdinalNumber: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FracGroupWells_FracGroup?: Array<FracGroupWell> | null;
  ScenarioDrillFracOverlaps_FracGroup?: Array<ScenarioDrillFracOverlap> | null;
  ScenarioWells_FracGroup?: Array<ScenarioWell> | null;
  ScenarioWellShutIns_FracGroup?: Array<ScenarioWellShutIn> | null;
  ScheduleActivities_FracGroup?: Array<ScheduleActivity> | null;
  GroupRelationships_FromFracGroup?: Array<GroupRelationship> | null;
  GroupRelationships_ToFracGroup?: Array<GroupRelationship> | null;
  ProductionGroups_SourceFracGroup?: Array<ProductionGroup> | null;
  Pad?: Pad;
  DrillGroup?: DrillGroup;

  constructor(item?: IFracGroup) {
    if (item) {

      this.FracGroupId = item.FracGroupId;
      this.ScenarioId = item.ScenarioId;
      this.FracFleetId = item.FracFleetId;
      this.Description = item.Description;
      this.ProcessingOrder = item.ProcessingOrder;
      this.Lag = item.Lag;
      this.InternalContingent = item.InternalContingent;
      this.InternalContingentComments = item.InternalContingentComments;
      this.Contingent = item.Contingent;
      this.ContingentComments = item.ContingentComments;
      this.PadId = item.PadId;
      this.BoundsOfWells_Computed = item.BoundsOfWells_Computed;
      this.CenterOfWells_Computed = item.CenterOfWells_Computed;
      this.BoundsofWellsSetDate = item.BoundsofWellsSetDate ? new Date(item.BoundsofWellsSetDate) : null;
      this.SourceDrillGroupId = item.SourceDrillGroupId;
      this.SysActionUID = item.SysActionUID;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.StartNoEarlierThan = item.StartNoEarlierThan ? new Date(item.StartNoEarlierThan) : null;
      this.StartNoLaterThan = item.StartNoLaterThan ? new Date(item.StartNoLaterThan) : null;
      this.FirstWellStart = item.FirstWellStart ? new Date(item.FirstWellStart) : null;
      this.LastWellEnd = item.LastWellEnd ? new Date(item.LastWellEnd) : null;
      this.FracDesignId = item.FracDesignId;
      this.IsManuallyAdded = item.IsManuallyAdded;
      this.IsFromBaseScenario = item.IsFromBaseScenario;
      this.SourceBaseScenarioFracGroupId = item.SourceBaseScenarioFracGroupId;
      this.SourceBaseScenarioDrillGroupId = item.SourceBaseScenarioDrillGroupId;
      this.CreationOrdinalNumber = item.CreationOrdinalNumber;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FracGroupWells_FracGroup = Helpers.createClassArray(FracGroupWell, item.FracGroupWells_FracGroup);
      this.ScenarioDrillFracOverlaps_FracGroup = Helpers.createClassArray(ScenarioDrillFracOverlap, item.ScenarioDrillFracOverlaps_FracGroup);
      this.ScenarioWells_FracGroup = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_FracGroup);
      this.ScenarioWellShutIns_FracGroup = Helpers.createClassArray(ScenarioWellShutIn, item.ScenarioWellShutIns_FracGroup);
      this.ScheduleActivities_FracGroup = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_FracGroup);
      this.GroupRelationships_FromFracGroup = Helpers.createClassArray(GroupRelationship, item.GroupRelationships_FromFracGroup);
      this.GroupRelationships_ToFracGroup = Helpers.createClassArray(GroupRelationship, item.GroupRelationships_ToFracGroup);
      this.ProductionGroups_SourceFracGroup = Helpers.createClassArray(ProductionGroup, item.ProductionGroups_SourceFracGroup);
      this.Pad = new Pad(item.Pad);
      this.DrillGroup = new DrillGroup(item.DrillGroup);
    }
  }
}